// eslint-disable-next-line import/extensions
import DeleteAddressBtn from './Addresses/deleteAddressBtn';
// eslint-disable-next-line import/extensions
import AddressBtn from './Addresses/addressBtn';

// eslint-disable-next-line import/extensions
import IndexTabControl from './News/IndexTabControl';

// eslint-disable-next-line import/extensions
import MyAccountCard from './Account/MyAccountCard';
// eslint-disable-next-line import/extensions
import PersonalDataBtn from './Account/personalDataBtn';
// eslint-disable-next-line import/extensions
import EmailBtn from './Account/emailBtn';
// eslint-disable-next-line import/extensions
import PasswordBtn from './Account/passwordBtn';
// eslint-disable-next-line import/extensions
import RemoveBtn from './Account/removeBtn';

customElements.define('delete-address-btn', DeleteAddressBtn, { extends: 'a' });
customElements.define('address-btn', AddressBtn, { extends: 'a' });

customElements.define('index-tab-control', IndexTabControl, { extends: 'button' });

customElements.define('my-account-card', MyAccountCard, { extends: 'div' });
customElements.define('edit-my-personal-data-btn', PersonalDataBtn, { extends: 'a' });
customElements.define('edit-my-email-btn', EmailBtn, { extends: 'a' });
customElements.define('edit-my-password-btn', PasswordBtn, { extends: 'a' });
customElements.define('remove-my-account-btn', RemoveBtn, { extends: 'a' });

import GeneratePassword from 'hegyd/core/resources/assets/js/components/Utils/GeneratePassword.js';
customElements.define('core-utils-generate-password', GeneratePassword,{extends: 'a'});
